import { Link, Typography } from '@mui/material';

const SupportRequest = () => {
  return (
    <>
      <Typography variant="h5">Soiling Mitigation Tool</Typography>
      <p>
        <Typography>
          For any bugs or technical issues encountered while using the tool, please contact{' '}
          <Link
            href={`mailto:houssem.essaidani@engie.com?subject=Soiling Mitigation Tool: Info Request&body=Hello,%0D%0A%0D%0A`}
            target="_blank"
          >
            Houssem Essaidani
          </Link>{' '}
        </Typography>
      </p>
      <p>
        <Typography>
          For improvement suggestions or feature requests, please complete the{' '}
          <Link
            href="https://engie.sharepoint.com/:x:/r/sites/RGBU-0001/DS13/Perf_Yield/SMT/Users%20Feedback/SMT_Users%20Feedback.xlsx?d=w4be7dff847884341b60e533fc852f3c9&csf=1&web=1&e=12Imhx"
            target="_blank"
          >
            feedback file
          </Link>
        </Typography>
      </p>
    </>
  );
};

export default SupportRequest;
